import React, { useEffect, useState } from 'react';
import '../css/button.css';
import { Navigate } from 'react-router-dom';
import anime, { set } from 'animejs';
import HomeButton from '../utils/HomeButton';

const Badong = (props) => {

    const [audio,] = useState(new Audio(process.env.PUBLIC_URL + '/assets/sounds/badung.mp3'));

    const clearAllTimeouts = () => {
        let id = window.setTimeout(() => { }, 0);
        while (id--) {
            window.clearTimeout(id);
        }
    }

    const clearAllAnim = () => {
        document.getElementById('rouge').style.opacity = 0;
        document.getElementById('bleu').style.opacity = 0;
        document.getElementById('vert').style.opacity = 0;
        document.getElementById('orange').style.opacity = 0;
        document.getElementById('cercle_bleu').style.opacity = 0;
        document.getElementById('cercle_orange').style.opacity = 0;
        document.getElementById('cercle_vert').style.opacity = 0;
        document.getElementById('te_text_1').style.opacity = 0;
        document.getElementById('al_text_1').style.opacity = 0;
        document.getElementById('lo_text_1').style.opacity = 0;
        document.getElementById('lo_text_1').style.top = '0px';
        document.getElementById('lo_text_1').style.left = '50px';
        document.getElementById('lo_text_2').style.opacity = 0;
        document.getElementById('na_text_2').style.opacity = 0;
        document.getElementById('re_text_2').style.opacity = 0;
        document.getElementById('re_text_2').style.top = '0px';
        document.getElementById('re_text_2').style.left = '50px';
        document.getElementById('re_text_3').style.opacity = 0;
        document.getElementById('ba_text_3').style.opacity = 0;
        document.getElementById('te_text_3').style.opacity = 0;
        document.getElementById('te_text_3').style.top = '0px';
        document.getElementById('te_text_3').style.left = '54px';
        document.getElementById('te_text_4').style.opacity = 0;
        document.getElementById('ra_text_4').style.opacity = 0;
    }

    const playTe = () => {
        clearAllTimeouts();
        clearAllAnim();
        const begin = 0;
        const end = 7.4;
        audio.currentTime = begin;
        audio.play();
        setTimeout(() => {
            audio.pause();
        }, (end - begin) * 1000);
        /* animation */
        document.getElementById('rouge').style.opacity = 1;
        document.getElementById('te_text_1').style.opacity = 1;
        //on décale un peu à droite
        document.getElementById('te_text_1').style.left = '30px';
        setTimeout(() => {
            document.getElementById('te_text_1').style.left = '0px';
            document.getElementById('rouge').style.opacity = 0;
            document.getElementById('al_text_1').style.opacity = 1;
            document.getElementById('lo_text_1').style.opacity = 1;
            document.getElementById('bleu').style.opacity = 1;
            anime({
                targets: '#lo_text_1',
                top: '195px',
                left: '35px',
                duration: 1000,
                easing: 'linear',
            });
        }, 6 * 1000);
    }

    const playLo = () => {
        clearAllTimeouts();
        clearAllAnim();
        const begin = 7.4;
        const end = 17.5;
        audio.currentTime = begin;
        audio.play();
        setTimeout(() => {
            audio.pause();
        }, (end - begin) * 1000);
        /* animation */
        document.getElementById('bleu').style.opacity = 1;
        document.getElementById('lo_text_2').style.opacity = 1;
        //on décale un peu à droite
        document.getElementById('lo_text_2').style.left = '30px';
        setTimeout(() => {
            document.getElementById('bleu').style.opacity = 0;
            document.getElementById('cercle_bleu').style.opacity = 1;
        }, (11.8 - begin) * 1000);
        setTimeout(() => {
            document.getElementById('lo_text_2').style.left = '0px';
            document.getElementById('na_text_2').style.opacity = 1;
            document.getElementById('re_text_2').style.opacity = 1;
            anime({
                targets: '#re_text_2',
                top: '-98px',
                left: '-67px',
                duration: 1000,
                easing: 'linear',
            });
        }, (15.4 - begin) * 1000);
        setTimeout(() => {
            document.getElementById('cercle_bleu').style.opacity = 0;
            document.getElementById('vert').style.opacity = 1;
        }, (17.3 - begin) * 1000);
    }

    const playRe = () => {
        clearAllTimeouts();
        clearAllAnim();
        const begin = 17.5;
        const end = 27.2;
        audio.currentTime = begin;
        audio.play();
        setTimeout(() => {
            audio.pause();
        }, (end - begin) * 1000);
        /* animation */
        document.getElementById('vert').style.opacity = 1;
        document.getElementById('re_text_3').style.opacity = 1;
        setTimeout(() => {
            document.getElementById('vert').style.opacity = 0;
            document.getElementById('cercle_vert').style.opacity = 1;
        }, (20.7 - begin) * 1000);
        setTimeout(() => {
            document.getElementById('ba_text_3').style.opacity = 1;
            document.getElementById('te_text_3').style.opacity = 1;
            anime({
                targets: '#te_text_3',
                top: '0px',
                left: '200px',
                duration: 1000,
                easing: 'linear',
            });
        }, (26 - begin) * 1000);
        setTimeout(() => {
            document.getElementById('cercle_vert').style.opacity = 0;
            document.getElementById('orange').style.opacity = 1;
        }, (27 - begin) * 1000);
    }

    const playTe2 = () => {
        clearAllTimeouts();
        clearAllAnim();
        const begin = 60 + 47;
        const end = 60 + 54;
        audio.currentTime = begin;
        audio.play();
        setTimeout(() => {
            audio.pause();
        }, (end - begin) * 1000);
        /* animation */
        document.getElementById('orange').style.opacity = 1;
        document.getElementById('te_text_4').style.opacity = 1;
        setTimeout(() => {
            document.getElementById('orange').style.opacity = 0;
            document.getElementById('cercle_orange').style.opacity = 1;
            document.getElementById('ra_text_4').style.opacity = 1;
        }, (60 + 51 - begin) * 1000);
    }

    const playAll = () => {
        clearAllTimeouts();
        clearAllAnim();
        const begin = 28.6;
        const end = 114;
        audio.currentTime = begin;
        setTimeout(() => {
            audio.pause();
        }, (end - begin) * 1000);
        audio.play();
        /*anim1*/
        setTimeout(() => {
            document.getElementById('rouge').style.opacity = 1;
            document.getElementById('te_text_1').style.opacity = 1;
            //on décale un peu à droite
            document.getElementById('te_text_1').style.left = '30px';
        }, (42 - begin) * 1000);
        setTimeout(() => {
            document.getElementById('te_text_1').style.left = '0px';
            document.getElementById('rouge').style.opacity = 0;
            document.getElementById('al_text_1').style.opacity = 1;
            document.getElementById('lo_text_1').style.opacity = 1;
            document.getElementById('bleu').style.opacity = 1;
            anime({
                targets: '#lo_text_1',
                top: '195px',
                left: '35px',
                duration: 1000,
                easing: 'linear',
            });
        }, (60 - begin) * 1000);
        setTimeout(() => {
            document.getElementById('te_text_1').style.opacity = 0;
            document.getElementById('al_text_1').style.opacity = 0;
            document.getElementById('lo_text_1').style.opacity = 0;
            document.getElementById('lo_text_2').style.opacity = 1;
            //on décale un peu à droite
            document.getElementById('lo_text_2').style.left = '30px';
        }, (61 - begin) * 1000);
        /*anim2*/
        setTimeout(() => {
            document.getElementById('bleu').style.opacity = 0;
            document.getElementById('cercle_bleu').style.opacity = 1;
        }, (67 - begin) * 1000);
        setTimeout(() => {
            document.getElementById('lo_text_2').style.left = '0px';
            document.getElementById('na_text_2').style.opacity = 1;
            document.getElementById('re_text_2').style.opacity = 1;
            anime({
                targets: '#re_text_2',
                top: '-98px',
                left: '-67px',
                duration: 1000,
                easing: 'linear',
            });
        }, (74 - begin) * 1000);
        setTimeout(() => {
            document.getElementById('cercle_bleu').style.opacity = 0;
            document.getElementById('vert').style.opacity = 1;
        }, (75 - begin) * 1000);
        setTimeout(() => {
            document.getElementById('lo_text_2').style.opacity = 0;
            document.getElementById('na_text_2').style.opacity = 0;
            document.getElementById('re_text_2').style.opacity = 0;
            document.getElementById('re_text_3').style.opacity = 1;
        }, (76 - begin) * 1000);
        /*anim3*/
        setTimeout(() => {
            document.getElementById('vert').style.opacity = 0;
            document.getElementById('cercle_vert').style.opacity = 1;
        }, (85 - begin) * 1000);
        setTimeout(() => {
            document.getElementById('ba_text_3').style.opacity = 1;
            document.getElementById('te_text_3').style.opacity = 1;
            anime({
                targets: '#te_text_3',
                top: '0px',
                left: '200px',
                duration: 1000,
                easing: 'linear',
            });
        }, (96 - begin) * 1000);
        setTimeout(() => {
            document.getElementById('cercle_vert').style.opacity = 0;
            document.getElementById('orange').style.opacity = 1;
        }, (97 - begin) * 1000);
        setTimeout(() => {
            document.getElementById('re_text_3').style.opacity = 0;
            document.getElementById('ba_text_3').style.opacity = 0;
            document.getElementById('te_text_3').style.opacity = 0;
            document.getElementById('te_text_4').style.opacity = 1;
        }, (98 - begin) * 1000);
        /*anim4*/
        setTimeout(() => {
            document.getElementById('orange').style.opacity = 0;
            document.getElementById('cercle_orange').style.opacity = 1;
            document.getElementById('ra_text_4').style.opacity = 1;
        }, (110 - begin) * 1000);
    }

    const stop = () => {
        clearAllTimeouts();
        clearAllAnim();
        audio.pause();
        audio.currentTime = 0;
    }

    useEffect(() => {
        clearAllAnim();
    }, []);

    function clearAll() {
        // Get a reference to the last interval + 1
        const interval_id = window.setInterval(function () { }, Number.MAX_SAFE_INTEGER);

        // Clear any timeout/interval up to that id
        for (let i = 1; i < interval_id; i++) {
            window.clearInterval(i);
        }

        props.audio.forEach(audio => audio.pause());
    }

    useEffect(() => {
        clearAll();

        props.audio.push(audio);

    }, []);


    return (
        <>
            <div
                className='background'
                style={{
                    backgroundColor: '#f0c759',
                }}
            />
            <HomeButton />
            <h2
                style={{
                    position: 'absolute',
                    top: '46px',
                    left: '50px',
                    zIndex: 2,
                    fontWeight: 'normal',
                    fontFamily: 'Times New Roman',
                    fontSize: '22px',
                    fontWeight: 'bold',
                }}
            >
                <i>Te allona batari</i> &nbsp; « en ce jour au firmament »
            </h2>
            <img
                src={process.env.PUBLIC_URL + "/assets/images/badung/pause1.png"}
                alt="pause"
                style={{
                    position: 'absolute',
                    top: '66px',
                    left: '540px',
                    height: '30px',
                    zIndex: 2,
                    cursor: 'pointer',
                }}
                onClick={stop}
            />
            <img
                src={process.env.PUBLIC_URL + "/assets/images/badung/fleche.png"}
                alt="fleche"
                style={{
                    position: 'absolute',
                    top: '66px',
                    left: '500px',
                    height: '30px',
                    zIndex: 2,
                    cursor: 'pointer',
                }}
                onClick={playAll}
            />
            <div
                style={{
                    cursor: 'pointer',
                }}
                onClick={playTe}
            >
                <img
                    src={process.env.PUBLIC_URL + "/assets/images/badung/rond_blanc.png"}
                    alt="rond"
                    className='Te'
                    style={{
                        position: 'absolute',
                        top: '150px',
                        left: '375px',
                        height: '30px',
                        zIndex: 2,
                    }}
                />
                <div id='leg1'
                    style={{
                        position: 'absolute',
                        top: '124px',
                        left: '376px',
                        fontFamily: 'Times New Roman',
                        fontSize: '26px',
                        fontWeight: 'bold',
                        zIndex: 6,
                        fontStyle: 'italic',
                    }}>
                    <p
                        style={{
                            color: 'red',
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                        }}>Te</p>
                </div>
            </div>
            <div
                style={{
                    cursor: 'pointer',
                }}
                onClick={playLo}
            >
                <img
                    src={process.env.PUBLIC_URL + "/assets/images/badung/rond_blanc.png"}
                    alt="rond"
                    style={{
                        position: 'absolute',
                        top: '150px',
                        left: '435px',
                        height: '30px',
                        zIndex: 2,
                    }}
                />
                <div id='leg2'
                    style={{
                        position: 'absolute',
                        top: '124px',
                        left: '440px',
                        fontFamily: 'Times New Roman',
                        fontSize: '26px',
                        fontWeight: 'bold',
                        zIndex: 6,
                        fontStyle: 'italic',
                    }}>
                    <p
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '-19px',
                        }}>al</p>
                    <p
                        style={{
                            color: 'blue',
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                        }}>lo</p>
                    <p
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '19px',
                        }}>na</p>
                </div>
            </div>
            <div
                style={{
                    cursor: 'pointer',
                }}
                onClick={playRe}
            >
                <img
                    src={process.env.PUBLIC_URL + "/assets/images/badung/rond_blanc.png"}
                    alt="rond"
                    style={{
                        position: 'absolute',
                        top: '150px',
                        left: '495px',
                        height: '30px',
                        zIndex: 2,
                    }}
                />
                <div id='leg3'
                    style={{
                        position: 'absolute',
                        top: '124px',
                        left: '500px',
                        fontFamily: 'Times New Roman',
                        fontSize: '26px',
                        fontWeight: 'bold',
                        zIndex: 6,
                        fontStyle: 'italic',
                    }}>
                    <p
                        style={{
                            color: 'green',
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                        }}>re</p>
                </div>
            </div>
            <div
                style={{
                    cursor: 'pointer',
                }}
                onClick={playTe2}
            >
                <img
                    src={process.env.PUBLIC_URL + "/assets/images/badung/rond_blanc.png"}
                    alt="rond"
                    style={{
                        position: 'absolute',
                        top: '150px',
                        left: '555px',
                        height: '30px',
                        zIndex: 2,
                    }}
                />
                <div id='leg4'
                    style={{
                        position: 'absolute',
                        top: '124px',
                        left: '560px',
                        fontFamily: 'Times New Roman',
                        fontSize: '26px',
                        fontWeight: 'bold',
                        zIndex: 6,
                        fontStyle: 'italic',
                    }}>
                    <p
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '-26px',
                        }}>ba</p>
                    <p
                        style={{
                            color: 'orange',
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                        }}>te</p>
                    <p
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '19px',
                        }}>ra</p>
                </div>
            </div>
            <img
                src={process.env.PUBLIC_URL + "/assets/images/badung/legende.png"}
                alt="legende"
                style={{
                    position: 'absolute',
                    top: '280px',
                    left: '355px',
                    width: '270px',
                    zIndex: 2,
                }}
            />
            <img
                src={process.env.PUBLIC_URL + "/assets/images/badung/cercle.png"}
                alt="cercle"
                style={{
                    position: 'absolute',
                    top: '150px',
                    left: '80px',
                    height: '270px',
                    zIndex: 2,
                }}
            />
            <img
                src={process.env.PUBLIC_URL + "/assets/images/badung/cercle_bleu.png"}
                alt="cercle"
                id="cercle_bleu"
                style={{
                    position: 'absolute',
                    top: '150px',
                    left: '80px',
                    height: '270px',
                    zIndex: 2,
                }}
            />
            <img
                src={process.env.PUBLIC_URL + "/assets/images/badung/cercle_orange.png"}
                alt="cercle"
                id="cercle_orange"
                style={{
                    position: 'absolute',
                    top: '150px',
                    left: '80px',
                    height: '270px',
                    zIndex: 2,
                }}
            />
            <img
                src={process.env.PUBLIC_URL + "/assets/images/badung/cercle_vert.png"}
                alt="cercle"
                id="cercle_vert"
                style={{
                    position: 'absolute',
                    top: '150px',
                    left: '80px',
                    height: '270px',
                    zIndex: 2,
                }}
            />
            <img
                src={process.env.PUBLIC_URL + "/assets/images/badung/rouge.png"}
                alt="cercle"
                id="rouge"
                style={{
                    position: 'absolute',
                    top: '151px',
                    left: '153px',
                    width: '120px',
                    zIndex: 2,
                }}
            />
            <div id='text1'
                style={{
                    position: 'absolute',
                    top: '150px',
                    left: '170px',
                    fontFamily: 'Times New Roman',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    zIndex: 6,
                    fontFamily: 'Times New Roman',
                }}>
                <p id='te_text_1'
                    style={{
                        color: 'red',
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                    }}>Te</p>
                <p id='al_text_1'
                    style={{
                        position: 'absolute',
                        top: '0px',
                        left: '33px',
                    }}>al</p>
                <p
                    id='lo_text_1'
                    style={{
                        color: 'blue',
                        position: 'absolute',
                        top: '0px',
                        left: '50px',
                    }}>lo</p>
            </div>

            <img
                src={process.env.PUBLIC_URL + "/assets/images/badung/bleu.png"}
                alt="cercle"
                id="bleu"
                style={{
                    position: 'absolute',
                    top: '397px',
                    left: '166px',
                    width: '88px',
                    zIndex: 2,
                }}
            />
            <div id='text2'
                style={{
                    position: 'absolute',
                    top: '355px',
                    left: '170px',
                    fontFamily: 'Times New Roman',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    zIndex: 6,
                    fontFamily: 'Times New Roman',
                }}>
                <p id='lo_text_2'
                    style={{
                        color: 'blue',
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                    }}>lo</p>
                <p id='na_text_2'
                    style={{
                        position: 'absolute',
                        top: '0px',
                        left: '24px',
                        fontFamily: 'Times New Roman',
                    }}>na</p>
                <p
                    id='re_text_2'
                    style={{
                        color: 'green',
                        position: 'absolute',
                        top: '0px',
                        left: '50px',
                    }}>re</p>
            </div>
            <img
                src={process.env.PUBLIC_URL + "/assets/images/badung/orange.png"}
                alt="cercle"
                id="orange"
                style={{
                    position: 'absolute',
                    top: '240px',
                    left: '325px',
                    height: '84px',
                    zIndex: 2,
                }}
            />
            <div id='text3'
                style={{
                    position: 'absolute',
                    top: '257px',
                    left: '106px',
                    fontFamily: 'Times New Roman',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    zIndex: 6,
                    fontFamily: 'Times New Roman',
                }}>
                <p id='re_text_3'
                    style={{
                        color: 'green',
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                    }}>re</p>
                <p id='ba_text_3'
                    style={{
                        position: 'absolute',
                        top: '0px',
                        left: '30px',
                    }}>ba</p>
                <p
                    id='te_text_3'
                    style={{
                        color: 'orange',
                        position: 'absolute',
                        top: '0px',
                        left: '54px',
                    }}>te</p>
            </div>
            <img
                src={process.env.PUBLIC_URL + "/assets/images/badung/vert.png"}
                alt="cercle"
                id="vert"
                style={{
                    position: 'absolute',
                    top: '252px',
                    left: '80px',
                    height: '84px',
                    zIndex: 2,
                }}
            />
            <div id='text4'
                style={{
                    position: 'absolute',
                    top: '257px',
                    left: '287px',
                    fontFamily: 'Times New Roman',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    zIndex: 6,
                    fontFamily: 'Times New Roman',
                }}>
                <p id='te_text_4'
                    style={{
                        color: 'orange',
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                    }}>te</p>
                <p id='ra_text_4'
                    style={{
                        position: 'absolute',
                        top: '0px',
                        left: '19px',
                    }}>ra</p>
            </div>
            <p
                style={{
                    position: 'absolute',
                    top: '104px',
                    left: '203px',
                    fontFamily: 'Times New Roman',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    zIndex: 6,
                }}
            >
                1
            </p>
            <p
                style={{
                    position: 'absolute',
                    top: '407px',
                    left: '203px',
                    fontFamily: 'Times New Roman',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    zIndex: 6,
                }}
            >
                2
            </p>
            <p
                style={{
                    position: 'absolute',
                    top: '258px',
                    left: '53px',
                    fontFamily: 'Times New Roman',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    zIndex: 6,
                }}
            >
                3
            </p>
            <p
                style={{
                    position: 'absolute',
                    top: '250px',
                    left: '360px',
                    fontFamily: 'Times New Roman',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    zIndex: 6,
                }}
            >
                4
            </p>
        </>
    );
}

export default Badong;